import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class ReportService {
    create(data) {
        return axios.post(API_URL+'report', data, { headers: authHeader() });
    }
    update(id, data) {
        return axios.post(API_URL+'report/update/'+id, data, { headers: authHeader() });
    }
    finish(id, data) {
        return axios.post(API_URL+'report/finish/'+id, data, { headers: authHeader() });
    }
    list() {
        return axios.get(API_URL+'report', { headers: authHeader() });
    }
    detail(id) {
        return axios.get(API_URL+'report/'+id, { headers: authHeader() });
    }
    validation(data) {
        return axios.post(API_URL+'report/verification', data, { headers: authHeader() });
    }
    search(data) {
        return axios.post(API_URL+'report/search', data, { headers: authHeader() });
    }
    advancedSearch(data) {
        return axios.post(API_URL+'report/advanced-search', data, { headers: authHeader() });
    }
    share(data) {
        return axios.post(API_URL+'report/share', data, { headers: authHeader() });
    }
    download(id) {
        return axios.get(API_URL+'report/download/'+id, { responseType: 'blob', headers: authHeader() });
    }
    delete(id) {
        return axios.delete(API_URL+'report/'+id, { headers: authHeader() });
    }
    test1() {
        return axios.get(API_URL+'report/test1', { headers: authHeader() });
    }
    test2() {
        return axios.get(API_URL+'report/test2', { headers: authHeader() });
    }
}

export default new ReportService();
